// @flow
import styled from '@emotion/styled'
import * as React from 'react'

import typeof { AnnouncementBar } from './AnnouncementBar'
import typeof * as Navigation from './navigation'

type Props = {
  children:
    | [
        ?React.Element<AnnouncementBar>,
        React.Element<$PropertyType<Navigation, 'Header'>>
      ]
    | [React.Element<$PropertyType<Navigation, 'Header'>>],
  ...
}

export const Header = React.forwardRef<Props, any>(
  ({ children, ...rest }, forwardedRef) => (
    <HeaderRoot {...rest} ref={forwardedRef}>
      {children}
    </HeaderRoot>
  )
)

const HeaderRoot = styled<Props>('div')`
  width: 100%;
  position: absolute;
  pointer-events: none;
  height: 100%;
  // FIXME: Value set unreasonably high, because of other unreasonable uses of z-index in the codebase.
  z-index: 99999;
`
